import { ClubPointsHistoryBlock } from 'cms-types'
import { type LoadableComponentProps, type LocalizedComponentProps } from 'ui'

import { ClubPointsHistoryClient } from './ClubPointsHistoryClient'

function ClubPointsHistory(
  props: LocalizedComponentProps<LoadableComponentProps<ClubPointsHistoryBlock>>,
) {
  return <ClubPointsHistoryClient {...props} />
}

export default ClubPointsHistory
ClubPointsHistory.loadable = true
